module.exports = __webpack_public_path__ + "media/images/games/clash-royale/card-epic-61ef633618e6b5dd7bcedad9f547c4d3.png";